import React, {useContext, useEffect, useState} from "react"
import PropTypes from "prop-types";
import {useParams} from "react-router";
import DemandOffersOfferService from "services/DemandOffersOfferService";
import Loading from "components/Loading";
import Form from "components/Form";
import {offerValidation} from "../constants/validation.form";
import SaveFormikValues from "components/SaveFormikValues";
import OfferPositionConditions from "../../../../../common/positions/OfferPositionConditions";
import OfferPositionCriteriums from "../../../../../common/positions/OfferPositionCriteriums";
import OfferPositionItems from "../../../../../common/positions/OfferPositionItems";
import OfferPositionParameters from "../../../../../common/positions/OfferPositionParameters";
import OfferPositionConsorciants from "../../../../../common/positions/OfferPositionConsorciants";
import DemandAdditionalOffersOfferService from "services/DemandAdditionalOffersOfferService";
import {ContractorConsorciumTypes} from "constants/ContractorConsorciumTypes";
import PurchaserOfferContext from "context/PurchaserOfferContext";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import Tr from "translations/Translations";
import {APIOfferPlacingType} from "../constants/APIOfferPlacingType";
import EditIcon from '@material-ui/icons/Edit';
import SpellcheckIcon from '@material-ui/icons/Spellcheck';
import {OfferMode} from "../../../../../common/constants/OfferMode";
import DemandOffersAuctionService from "services/DemandOffersAuctionService";
import {RoundType} from "constants/RoundType";
import SnapshotListPopup, {getConfig} from "../../SnapshotListPopup";
import HistoryIcon from "@material-ui/icons/History";
import VerificationsPopup, {getVerificationConfig} from "../../VerificationsPopup";
import SignatureIcon from "components/icon/SignatureIcon";
import OfferSectionContext from "context/OfferSectionContext";
import scrollTo from "libs/scrollTo";
import useSalesNotification from "hooks/useSalesNotification";
import salesNotificationKeys from "components/popup/salesNotification/constants/salesNotification.keys";
import VatType from "constants/VatType";
import {PriceTypeGrossFieldVisible, PriceTypeNetFieldVisible, PriceTypeVatFieldVisible} from "constants/PriceTypes";
import {calcNetGros} from "../../../../../common/positions/inputs/OfferPriceInput";
import {
    AlertsForOfferProvider
} from "../../../../../../../../../../../context/AlertsForOfferContext";
import {setResource, setSaveStatusError} from "redux/actions";
import reduxStore from 'redux/store'

const formatAmount = (value) => {
    if (value === null || value === undefined || value === '') {
        return value;
    }
    const parsed = parseFloat(value);
    return isNaN(parsed) ? value : parsed.toFixed(2);
}

function OfferPositionForm(
    {
        position,
        loadedPosition,
        expanded,
        setExpanded,
        working,
        setWorking,
        disabled,
        formId,
        mode,
        roundType,
        offerEdit
    }) {

    const params = useParams();
    const demandId = params.id;
    const stageId = params.stageId;
    const [loadedPositionCounted, setLoadedPositionCounted] = useState(null);
    const purchaserOfferContext = useContext(PurchaserOfferContext);
    const contextSection = useContext(OfferSectionContext);
    const [chooseSnapshotPopup, setChooseSnapshotPopup] = useState(null);
    const [verifyPopup, setVerifyPopup] = useState(null);
    const [alerts, setAlerts] = useState(null);
    const VATIN_WRONG_VALUE = "vatinwrongvalue";

    const getOfferPosition = () => {
        switch (roundType) {
            case RoundType.BASE:
                DemandOffersOfferService.getOfferPosition(demandId, stageId, mode, position.positionId, purchaserOfferContext?.supplierId, purchaserOfferContext?.preview);
                break;
            case RoundType.ADDITIONAL_OFFERS:
                DemandAdditionalOffersOfferService.getOfferPosition(demandId, stageId, mode, position.positionId, purchaserOfferContext?.supplierId);
                break;
            case RoundType.AUCTION:
                DemandOffersAuctionService.getOfferPosition(demandId, stageId, mode, position.positionId, purchaserOfferContext?.supplierId);
                break;
            default:
                throw new Error("Unknown roundType: " + roundType)
        }
    }

    useEffect(() => {
        if (expanded && !loadedPosition) {
            getOfferPosition();
        }
        // eslint-disable-next-line
    }, [expanded, loadedPosition, position, demandId, stageId, mode, roundType, purchaserOfferContext])

    const handleSubmit = (values, actions) => {
        setWorking(true);
        let promise;
        switch (roundType) {
            case RoundType.BASE:
                promise = DemandOffersOfferService.postSavePositionData(demandId, stageId, purchaserOfferContext?.supplierId, mode, values)
                break;
            case RoundType.ADDITIONAL_OFFERS:
                promise = DemandAdditionalOffersOfferService.postSavePositionData(demandId, stageId, purchaserOfferContext?.supplierId, mode, values)
                break;
            case RoundType.AUCTION:
                promise = DemandOffersAuctionService.postSavePositionData(demandId, stageId, purchaserOfferContext?.supplierId, mode, values)
                break;
            default:
                throw new Error("Unknown roundType: " + roundType)
        }

        promise.then((errorsAndAlerts) => {
            let hasFieldErrors = false;
            if (errorsAndAlerts) {
                if ('alerts' in errorsAndAlerts) {
                    const alertsMap = errorsAndAlerts.alerts;

                    const alerts = new Map();

                    Object.keys(alertsMap).forEach((key) => {
                        const transformedKey = key.replaceAll("[", ".").replaceAll("]", "");
                        alerts.set(transformedKey, alertsMap[key]);
                    });

                    setAlerts(alerts);
                }
                if ('errors' in errorsAndAlerts) {
                    const errors = errorsAndAlerts.errors;
                    if (Object.keys(errors).length > 0) {
                        hasFieldErrors = true;
                        Object.keys(errors).forEach((key) => {
                            actions.setFieldError(key.replaceAll("[", ".").replaceAll("]", ""), errors[key]);
                        })
                        setTimeout((formId) => scrollTo("#" + formId + " .MuiFormHelperText-root.Mui-error", 200), 100, formId);
                    }
                }
                if (Object.values(errorsAndAlerts).some((errorValue) => errorValue === VATIN_WRONG_VALUE)) {
                    hasFieldErrors = true;
                    reduxStore.dispatch(setResource('offerPositionFormId', formId));
                    reduxStore.dispatch(setSaveStatusError(Tr(VATIN_WRONG_VALUE)));
                }
            }
            if (!hasFieldErrors) {
                setLoadedPositionCounted(null)
                getOfferPosition();
                setExpanded(false);
                setTimeout((formId) => scrollTo("#wrap_" + formId, 0), 100, formId);
            }
        }).finally(() => setWorking(false))
    }

    const handleReset = (values, actions) => {
        reduxStore.dispatch(setResource('commonDataErrors', []));
        setExpanded(false);
    }


    useEffect(() => {
        if (!!loadedPosition) {

            const show = {
                netField: PriceTypeNetFieldVisible(loadedPosition.priceType),
                grossField: PriceTypeGrossFieldVisible(loadedPosition.priceType),
                vatField: PriceTypeVatFieldVisible(loadedPosition.priceType),
            }




            const counted = {
                ...loadedPosition,
                consorciumOnPosition: !!loadedPosition.consorciumOnPosition,
                itemOffers: loadedPosition.itemOffers.map((x, i) => {
                    const values = {
                        netValue: show.netField ? x.value : null,
                        grossValue: show.grossField ? x.grossValue : null,
                        vatType: show.vatField ? x.vatType : null,
                        vatValue: show.vatField ? x.vatValue : null
                    }
                    const [roundedNet, roundedGross] = calcNetGros(values, !!x.quantity ? x.quantity : x.criterium.quantity, loadedPosition.priceType);

                    return {
                        ...x,
                        value: formatAmount(x.value),
                        grossValue: formatAmount(x.grossValue),
                        vatType: x.vatType === VatType.STANDARD && x.vatValue === null ? null : x.vatType,
                        totalNet: formatAmount(roundedNet),
                        totalGross: formatAmount(roundedGross)
                    }
                }),
                criteriums: loadedPosition.criteriums.map(x => ({
                    ...x,
                    vatType: x.vatType === VatType.STANDARD && x.vatValue === null ? null : x.vatType
                }))
            }
            setLoadedPositionCounted(counted);
        }
    }, [loadedPosition])
    const printVerificationSalesCheck = useSalesNotification(salesNotificationKeys.SIGNATURE_VERIFICATOR, () => setVerifyPopup(getVerificationConfig(demandId, stageId, purchaserOfferContext?.supplierId, RoundType.ADDITIONAL_OFFERS, position.positionId)));
    const getButtons = (formikProps) => {
        const buttons = [];
        if (!!purchaserOfferContext && mode === OfferMode.PLACED && !offerEdit.passiveOfferForm && !!loadedPosition && !loadedPosition.disabled) {
            buttons.push(createButton(Tr('operator.modify.correct'), () => formikProps.setFieldValue("placingType", APIOfferPlacingType.CORRECTION, false),
                undefined, working || disabled || !!formikProps.values.placingType, undefined, false, SpellcheckIcon));
            buttons.push(createButton(Tr('operator.modify.update'), () => formikProps.setFieldValue("placingType", APIOfferPlacingType.UPDATE, false),
                undefined, working || disabled || !!formikProps.values.placingType, undefined, false, EditIcon));
        }

        if (!contextSection.additionalOfferAltMode) {
            if (!!purchaserOfferContext && mode === OfferMode.PLACED && roundType !== RoundType.BASE) {
                buttons.push(createButton(Tr("verify_documents"), printVerificationSalesCheck, undefined, false, undefined, false, SignatureIcon));
            }
            if (roundType !== RoundType.BASE) {
                buttons.push(createButton(Tr("change_history"), () => setChooseSnapshotPopup(getConfig(demandId, stageId, purchaserOfferContext?.supplierId, RoundType.ADDITIONAL_OFFERS, position.positionId)),
                    "outlined", false, undefined, false, HistoryIcon));
            }

        }
        return buttons;
    }

    return (<>
        {
            !loadedPositionCounted ?
                <Loading/>
                :
                <AlertsForOfferProvider value={alerts}>
                    <Form
                        id={formId}
                        htmlFormId={formId}
                        initialValues={loadedPositionCounted}
                        validationSchema={offerValidation}
                        validateOnChange={false}
                        onSubmit={handleSubmit}
                        onReset={handleReset}
                    >
                        {(formikProps) => {
                            const formDisabled = working || disabled || !loadedPositionCounted || loadedPositionCounted.disabled ||
                                (purchaserOfferContext && !formikProps.values.placingType && mode === OfferMode.PLACED)


                            return (<>

                                    <MultiButton justify="flex-end" buttons={getButtons(formikProps)}/>

                                    {!offerEdit.passiveOfferForm && <>
                                        <SaveFormikValues
                                            formikProps={formikProps}
                                            id={formId}
                                        />
                                        {offerEdit.commonData.consorciumType === ContractorConsorciumTypes.POSITION &&
                                            <OfferPositionConsorciants
                                                disabled={formDisabled || roundType !== RoundType.BASE || loadedPositionCounted.hadStageWithOffer}
                                                formikProps={formikProps} offerEdit={offerEdit}
                                                positionId={position.positionId}
                                                positionFormId={formId}/>
                                        }

                                        <OfferPositionConditions disabled={formDisabled} conditions={loadedPositionCounted.conditions}
                                                                 formikProps={formikProps} priceType={loadedPositionCounted.priceType}/>
                                        <OfferPositionCriteriums disabled={formDisabled} criteriums={loadedPositionCounted.criteriums}
                                                                 formikProps={formikProps} priceType={loadedPositionCounted.priceType}/>
                                        <OfferPositionItems disabled={formDisabled} itemOffers={loadedPositionCounted.itemOffers}
                                                            formikProps={formikProps} priceType={loadedPositionCounted.priceType} mode={mode}/>
                                        <OfferPositionParameters disabled={formDisabled} parameters={loadedPositionCounted.parameters}
                                                                 formikProps={formikProps} priceType={loadedPositionCounted.priceType}/>
                                    </>}
                                    {
                                        !!chooseSnapshotPopup && <SnapshotListPopup
                                            onClose={() => setChooseSnapshotPopup(null)}
                                            config={chooseSnapshotPopup}
                                        />
                                    }
                                    {
                                        !!verifyPopup && <VerificationsPopup
                                            onClose={() => setVerifyPopup(null)}
                                            config={verifyPopup}
                                        />
                                    }
                                </>
                            )
                        }
                        }
                    </Form>
                </AlertsForOfferProvider>
        }

    </>)


}

OfferPositionForm.propTypes = {
    position: PropTypes.shape({
        identity: PropTypes.number.isRequired,
        positionId: PropTypes.number.isRequired
    }),
    expanded: PropTypes.bool.isRequired,
    setExpanded: PropTypes.func.isRequired,
    working: PropTypes.bool.isRequired,
    setWorking: PropTypes.func.isRequired,
    formId: PropTypes.string.isRequired,
    roundType: PropTypes.oneOf(Object.keys(RoundType)).isRequired,
    offerEdit: PropTypes.shape({
        contractor: PropTypes.shape({}),
        commonData: PropTypes.shape({
            consorciumType: PropTypes.oneOf(Object.keys(ContractorConsorciumTypes)).isRequired
        }).isRequired
    }).isRequired
}

export default OfferPositionForm;